import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaChevronLeft, FaChevronRight, FaWhatsapp } from 'react-icons/fa';
import styles from './mayzamoreira_lashdesign_procedimentos.module.scss';

const WHATSAPP_NUMBER = '5532998055394';

const agendarMsg = (titulo: string) =>
    `Olá, tudo bem? Vim pelo Instagram e gostaria de agendar o procedimento ${titulo}.`;

type Procedimento = {
    titulo: string;
    descricao: string;
    aplicacao?: string;
    manutencao?: string;
    valor?: string;
    imagens: string[];
    whatsappMessage: string;
};

const procedimentos: Procedimento[] = [
    {
        titulo: 'Volume 3D',
        descricao: 'Ideal pra quem quer olhar marcante, mas ainda delicado.',
        aplicacao: 'R$ 110,00',
        manutencao: 'R$ 97,00',
        imagens: [
            require('./src/procedimentos/Volume 3D 1.png'),
            require('./src/procedimentos/Volume 3D.png'),
        ],
        whatsappMessage: agendarMsg('Volume 3D'),
    },
    {
        titulo: 'Volume 4D',
        descricao: 'Ideal pra quem quer destacar o olhar sem ficar muito carregado.',
        aplicacao: 'R$ 118,00',
        manutencao: 'R$ 100,00',
        imagens: [require('./src/procedimentos/Volume 4D.png')],
        whatsappMessage: agendarMsg('Volume 4D'),
    },
    {
        titulo: 'Volume 5D',
        descricao: 'Indicado pra quem gosta de cílios chamativos, estilo diva.',
        aplicacao: 'R$ 135,00',
        manutencao: 'R$ 100,00',
        imagens: [require('./src/procedimentos/Volume 5D.png')],
        whatsappMessage: agendarMsg('Volume 5D'),
    },
    {
        titulo: 'Volume 6D',
        descricao: 'Cria um olhar intenso, marcante e super cheio, perfeito pra quem gosta de destaque.',
        aplicacao: 'R$ 140,00',
        manutencao: 'R$ 110,00',
        imagens: [
            require('./src/procedimentos/Volume 6D 1.png'),
            require('./src/procedimentos/Volume 6D.png'),
        ],
        whatsappMessage: agendarMsg('Volume 6D'),
    },
    {
        titulo: 'Volume Fox Eyes',
        descricao: 'Dá um visual levantado e puxadinho, perfeito pra quem ama um olhar marcante.',
        aplicacao: 'R$ 125,00',
        manutencao: 'R$ 100,00',
        imagens: [require('./src/procedimentos/Volume Fox Eyes.png')],
        whatsappMessage: agendarMsg('Volume Fox Eyes'),
    },
    {
        titulo: 'Volume Diva',
        descricao: 'Ideal pra quem quer aquele efeito de cílios de boneca ou de palco, cheio de presença.',
        aplicacao: 'R$ 150,00',
        manutencao: 'Capping, não tem manutenção',
        imagens: [require('./src/procedimentos/Volume Diva.png')],
        whatsappMessage: agendarMsg('Volume Diva'),
    },
    {
        titulo: 'Volume Brasileiro',
        descricao:
            'Um olhar marcante, com volume na medida certa e um acabamento delicado que realça a beleza natural dos seus olhos.',
        aplicacao: 'R$ 120,00',
        manutencao: 'R$ 100,00',
        imagens: [require('./src/procedimentos/volume brasileiro.png')],
        whatsappMessage: agendarMsg('Volume Brasileiro'),
    },
    {
        titulo: 'Lash Lifting',
        descricao: 'Cílios naturais, curvados e com efeito de máscara 24h.',
        valor: 'R$ 85,00',
        imagens: [require('./src/procedimentos/Lash Lifting.png')],
        whatsappMessage: agendarMsg('Lash Lifting'),
    },
    {
        titulo: 'Brow Lamination',
        descricao: 'Adeus falhas! Brow Lamination deixa suas sobrancelhas mais cheias e definidas.',
        valor: 'R$ 95,00',
        imagens: [
            require('./src/procedimentos/Brow Lamination 1.png'),
            require('./src/procedimentos/Brow Lamination.png'),
        ],
        whatsappMessage: agendarMsg('Brow Lamination'),
    },
    {
        titulo: 'Volume Brown',
        descricao: 'Para quem ama um efeito natural, os cílios brown são perfeitos.',
        aplicacao: 'R$ 145,00',
        manutencao: 'R$ 120,00',
        imagens: [require('./src/procedimentos/Volume Brown.png')],
        whatsappMessage: agendarMsg('Volume Brown'),
    },
    {
        titulo: 'Design Comum',
        descricao: 'Ideal pra quem quer manter o visual sempre bonito e bem cuidado.',
        valor: 'R$ 35,00',
        imagens: [
            require('./src/procedimentos/Design Comum 1.png'),
            require('./src/procedimentos/Design Comum.png'),
        ],
        whatsappMessage: agendarMsg('Design Comum'),
    },
    {
        titulo: 'Design Com Henna',
        descricao:
            'Ideal pra quem quer um visual mais preenchido e expressivo, mas sem precisar de maquiagem todos os dias.',
        valor: 'R$ 45,00',
        imagens: [
            require('./src/procedimentos/Design Com Henna 1.png'),
            require('./src/procedimentos/Design Com Henna.png'),
        ],
        whatsappMessage: agendarMsg('Design Com Henna'),
    },
    {
        titulo: 'Remoção de Cílios',
        descricao:
            'Chegou a hora de remover os cílios? Nada de puxar ou arrancar em casa! Aqui a remoção é feita com todo cuidado, protegendo seus fios naturais e mantendo a saúde dos seus cílios.',
        valor: 'R$ 35,00',
        imagens: [require('./src/procedimentos/Remoção Cílios.png')],
        whatsappMessage: agendarMsg('Remoção de Cílios'),
    },
    {
        titulo: 'Hydragloss Comum',
        descricao:
            'Lábios hidratados nunca saem de moda. O Hydragloss devolve a maciez, o brilho e o volume natural que a sua boca merece. Perfeito pra quem ama um efeito natural e saudável.',
        valor: 'R$ 50,00',
        imagens: [require('./src/procedimentos/Hydragloss Comum.png')],
        whatsappMessage: agendarMsg('Hydragloss Comum'),
    },
    {
        titulo: 'Hydragloss Com Henna Labial',
        descricao:
            'O Hydragloss com henna labial realça um tom natural da boca, hidrata profundamente e deixa aquele brilho saudável e volumoso. A henna dá uma leve corzinha, e o hydragloss garante lábios macios e iluminados.',
        valor: 'R$ 60,00',
        imagens: [require('./src/procedimentos/Hydragloss Com Henna Labial.png')],
        whatsappMessage: agendarMsg('Hydragloss Com Henna Labial'),
    },
    {
        titulo: 'Epilação de Buço',
        descricao: 'Remove os pelinhos finos da região do buço com cera, deixando a pele lisinha.',
        valor: 'R$ 20,00',
        imagens: [require('./src/procedimentos/Epilação de Buço.png')],
        whatsappMessage: agendarMsg('Epilação de Buço'),
    },
];

const getWhatsappUrl = (message: string) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

interface CardProcedimentoProps {
    titulo: string;
    descricao: string;
    aplicacao?: string;
    manutencao?: string;
    valor?: string;
    imagens: string[];
    whatsappMessage: string;
}

const CardProcedimento: React.FC<CardProcedimentoProps> = ({
    titulo,
    descricao,
    aplicacao,
    manutencao,
    valor,
    imagens,
    whatsappMessage,
}) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const hasMultipleImages = imagens.length > 1;
    const hasImage = imagens.length > 0;

    const prevImage = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!hasMultipleImages) return;
        setCurrentIndex((prev) => (prev === 0 ? imagens.length - 1 : prev - 1));
    };

    const nextImage = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!hasMultipleImages) return;
        setCurrentIndex((prev) => (prev === imagens.length - 1 ? 0 : prev + 1));
    };

    return (
        <article className={styles.card}>
            {hasImage ? (
                <div className={styles.carouselContainer}>
                    <img src={imagens[currentIndex]} alt={titulo} className={styles.carouselImage} />
                    {hasMultipleImages && (
                        <>
                            <button
                                type="button"
                                className={`${styles.carouselBtn} ${styles.prevBtn}`}
                                onClick={prevImage}
                                aria-label="Imagem anterior"
                            >
                                <FaChevronLeft />
                            </button>
                            <button
                                type="button"
                                className={`${styles.carouselBtn} ${styles.nextBtn}`}
                                onClick={nextImage}
                                aria-label="Próxima imagem"
                            >
                                <FaChevronRight />
                            </button>
                            <div className={styles.indicators}>
                                {imagens.map((_, idx) => (
                                    <span
                                        key={idx}
                                        role="button"
                                        tabIndex={0}
                                        className={`${styles.dot} ${idx === currentIndex ? styles.active : ''}`}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setCurrentIndex(idx);
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                setCurrentIndex(idx);
                                            }
                                        }}
                                        aria-label={`Ir para imagem ${idx + 1}`}
                                    />
                                ))}
                            </div>
                        </>
                    )}
                </div>
            ) : null}

            <h3 className={styles.cardTitle}>{titulo}</h3>
            <p className={styles.descricao}>{descricao}</p>

            <div className={styles.precos}>
                {aplicacao ? (
                    <p>
                        <span className={styles.precoLabel}>Aplicação:</span> {aplicacao}
                    </p>
                ) : null}
                {manutencao ? (
                    <p>
                        <span className={styles.precoLabel}>Manutenção:</span> {manutencao}
                    </p>
                ) : null}
                {valor ? (
                    <p>
                        <span className={styles.precoLabel}>Valor:</span> {valor}
                    </p>
                ) : null}
            </div>

            <a
                href={getWhatsappUrl(whatsappMessage)}
                className={styles.whatsappBtn}
                target="_blank"
                rel="noopener noreferrer"
            >
                <FaWhatsapp aria-hidden />
                <span>Agendar</span>
            </a>
        </article>
    );
};

const Mayzamoreira_lashdesign_procedimentos: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.mayzamoreira_lashdesign_procedimentos}>
            <div className={styles.header}>
                <Link
                    to="/mayzamoreira_lashdesign"
                    state={{ skipLoader: true }}
                    className={styles.backButton}
                    aria-label="Voltar ao cartão digital"
                >
                    <FaArrowLeft />
                </Link>
                <h1 className={styles.pageTitle}>Procedimentos</h1>
            </div>

            <div className={styles.lista}>
                {procedimentos.map((item) => (
                    <CardProcedimento
                        key={item.titulo}
                        titulo={item.titulo}
                        descricao={item.descricao}
                        aplicacao={item.aplicacao}
                        manutencao={item.manutencao}
                        valor={item.valor}
                        imagens={item.imagens}
                        whatsappMessage={item.whatsappMessage}
                    />
                ))}

                <aside className={styles.manutencaoInfo}>
                    <h2>Manutenção</h2>
                    <p>
                        A manutenção de cílios é feita, em média, a cada 15 a 20 dias, pra repor os fios que caíram
                        naturalmente e manter o alongamento sempre bonito e cheio. Assim, seus cílios continuam
                        alinhados, sem falhas e com aquele efeito perfeito por muito mais tempo.
                    </p>
                </aside>
            </div>
        </div>
    );
};

export default Mayzamoreira_lashdesign_procedimentos;
